import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Container,
  Typography,
  CircularProgress,
  Box,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
} from "@mui/material";
// components

import Iconify from "../components/iconify";
import axios from "axios";
// ----------------------------------------------------------------------
export const PLAYOFF_TEAMS = [
  {
    team_id: null,
    nickname: "",
    city: "",
    display_name: "Unknown",
    abbreviation: "",
    twitter_handle: "",
    hex_code: "",
    display_seed: "",
  },
  {
    team_id: 25,
    nickname: "",
    city: "",
    display_name: "Dallas Stars",
    abbreviation: "",
    twitter_handle: "",
    hex_code: "",
    display_seed: "",
  },
  {
    team_id: 21,
    nickname: "",
    city: "",
    display_name: "Colorado Avalanche",
    abbreviation: "",
    twitter_handle: "",
    hex_code: "",
    display_seed: "",
  },
  {
    team_id: 30,
    nickname: "",
    city: "",
    display_name: "Minnesota Wild",
    abbreviation: "",
    twitter_handle: "",
    hex_code: "",
    display_seed: "",
  },
  {
    team_id: 26,
    nickname: "",
    city: "",
    display_name: "Los Angeles Kings",
    abbreviation: "",
    twitter_handle: "",
    hex_code: "",
    display_seed: "",
  },
  {
    team_id: 22,
    nickname: "",
    city: "",
    display_name: "Edmonton Oilers",
    abbreviation: "",
    twitter_handle: "",
    hex_code: "",
    display_seed: "",
  },
  {
    team_id: 6,
    nickname: "",
    city: "",
    display_name: "Boston Bruins",
    abbreviation: "",
    twitter_handle: "",
    hex_code: "",
    display_seed: "",
  },
  {
    team_id: 13,
    nickname: "",
    city: "",
    display_name: "Florida Panthers",
    abbreviation: "",
    twitter_handle: "",
    hex_code: "",
    display_seed: "",
  },
  {
    team_id: 12,
    nickname: "",
    city: "",
    display_name: "Carolina Hurricanes",
    abbreviation: "",
    twitter_handle: "",
    hex_code: "",
    display_seed: "",
  },
  {
    team_id: 3,
    nickname: "",
    city: "",
    display_name: "New York Rangers",
    abbreviation: "",
    twitter_handle: "",
    hex_code: "",
    display_seed: "",
  },
  {
    team_id: 55,
    nickname: "",
    city: "",
    display_name: "Seattle Kraken",
    abbreviation: "",
    twitter_handle: "",
    hex_code: "",
    display_seed: "",
  },
  {
    team_id: 54,
    nickname: "",
    city: "",
    display_name: "Vegas Golden Knights",
    abbreviation: "",
    twitter_handle: "",
    hex_code: "",
    display_seed: "",
  },
  {
    team_id: 52,
    nickname: "",
    city: "",
    display_name: "Winnipeg Jets",
    abbreviation: "",
    twitter_handle: "",
    hex_code: "",
    display_seed: "",
  },
  {
    team_id: 10,
    nickname: "",
    city: "",
    display_name: "Toronto Maple Leafs",
    abbreviation: "",
    twitter_handle: "",
    hex_code: "",
    display_seed: "",
  },
  {
    team_id: 14,
    nickname: "",
    city: "",
    display_name: "Tampa Bay Lightning",
    abbreviation: "",
    twitter_handle: "",
    hex_code: "",
    display_seed: "",
  },
  {
    team_id: 2,
    nickname: "",
    city: "",
    display_name: "New York Islanders",
    abbreviation: "",
    twitter_handle: "",
    hex_code: "",
    display_seed: "",
  },
  {
    team_id: 1,
    nickname: "",
    city: "",
    display_name: "New Jersey Devils",
    abbreviation: "",
    twitter_handle: "",
    hex_code: "",
    display_seed: "",
  },
];

const getSequenceSeries = (sequence, series) => {
  return series.filter(
    (series_item) => series_item.round_sequence === sequence
  );
};

const SeriesInput = (props) => {
  const { series, updateHandler } = props;

  const handleChangeHomeTeam = (event) => {
    updateHandler(series.id, "team_1_id", event.target.value);
  };
  const handleChangeAwayTeam = (event) => {
    updateHandler(series.id, "team_2_id", event.target.value);
  };
  const handleChangeWinTeam = (event) => {
    updateHandler(series.id, "winner_id", event.target.value);
  };
  const handleChangeTextInput = (e) => {
    const { id, value } = e.target;

    updateHandler(series.id, id, value);
  };
  const handleChangeScored = (e) => {
    updateHandler(series.id, "is_scored", e.target.checked);
  };
  return (
    <Card key={`card-series-${series.id}`} sx={{ padding: 4, m: 1 }}>
      <Typography variant="h6" gutterBottom>
        Series {series.id}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <FormControl fullWidth>
            <InputLabel id="team_1_id-select-label">Home Team</InputLabel>
            <Select
              labelId="team_1_id-label"
              id="team_1_id-select"
              value={series.team_1_id}
              label="Home Team"
              onChange={handleChangeHomeTeam}
            >
              {PLAYOFF_TEAMS.map((team) => (
                <MenuItem
                  key={`home-team-series-${series.id}-team-${team.team_id}`}
                  value={team.team_id}
                >
                  {team.display_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <FormControl fullWidth>
            <InputLabel id="status-select-label">Away Team</InputLabel>
            <Select
              labelId="team_2_id-label"
              id="team_2_id-select"
              value={series.team_2_id}
              label="Type"
              onChange={handleChangeAwayTeam}
            >
              {PLAYOFF_TEAMS.map((team) => (
                <MenuItem
                  key={`away-team-series-${series.id}-team-${team.team_id}`}
                  value={team.team_id}
                >
                  {team.display_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <FormControl fullWidth>
            <InputLabel id="winner_id-select-label">Winner</InputLabel>
            <Select
              labelId="winner_id-label"
              id="winner_id-select"
              value={series.winner_id ?? ""}
              label="Type"
              onChange={handleChangeWinTeam}
            >
              {PLAYOFF_TEAMS.map((team) => (
                <MenuItem
                  key={`win-team-series-${series.id}-team-${team.team_id}`}
                  value={team.team_id}
                >
                  {team.display_name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={4}>
          <TextField
            label="Home Team Wins"
            id="team_1_wins"
            variant="standard"
            value={series.team_1_wins ?? ""}
            onChange={handleChangeTextInput}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            label="Away Team Wins"
            id="team_2_wins"
            variant="standard"
            value={series.team_2_wins ?? ""}
            onChange={handleChangeTextInput}
          />
        </Grid>
        <Grid item xs={4}>
          <FormControlLabel
            control={
              <Checkbox
                checked={series.is_scored}
                onChange={handleChangeScored}
                id="scored"
              />
            }
            label="Scored"
          />
        </Grid>
      </Grid>
    </Card>
  );
};

export default function SeriesResultsPage() {
  const [loading, setLoading] = useState(false);
  const [series, setSeries] = useState(null);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/game`)
      .then(function (response) {
        //console.log("response.data", response.data);
        setSeries(response.data.game.series_results);
      });
  }, []);

  const handleChange = (seriesId, property, value) => {
    const updatedSeries = series;
    const index = updatedSeries.findIndex((item) => item.id === seriesId);
    if (index !== -1) {
      updatedSeries[index][property] = value;
      setSeries([...updatedSeries]);
    }
  };

  const saveChanges = () => {
    setLoading(true);
    axios
      .put(`${process.env.REACT_APP_API_BASE_URL}/admin/game-series`, {
        series,
      })
      .then(function (response) {
        window.location.reload(false);
      });
  };

  return (
    <>
      <Helmet>
        <title> Series Results </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Series Results
          </Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:save-outline" />}
            onClick={() => saveChanges()}
          >
            Save
          </Button>
        </Stack>
        {series === null || loading ? (
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            style={{ padding: 20 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Grid container>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ textAlign: "center", m: 2 }}>
                First Round
              </Typography>
              {getSequenceSeries(1, series).map((series_item) => (
                <SeriesInput
                  key={`series-input-${series_item.id}`}
                  series={series_item}
                  updateHandler={handleChange}
                />
              ))}
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ textAlign: "center", m: 4 }}>
                Second Round
              </Typography>
              {getSequenceSeries(2, series).map((series_item) => (
                <SeriesInput
                  key={`series-input-${series_item.id}`}
                  series={series_item}
                  updateHandler={handleChange}
                />
              ))}
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ textAlign: "center", m: 4 }}>
                Third Round
              </Typography>
              {getSequenceSeries(3, series).map((series_item) => (
                <SeriesInput
                  key={`series-input-${series_item.id}`}
                  series={series_item}
                  updateHandler={handleChange}
                />
              ))}
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ textAlign: "center", m: 4 }}>
                Final
              </Typography>
              {getSequenceSeries(4, series).map((series_item) => (
                <SeriesInput
                  key={`series-input-${series_item.id}`}
                  series={series_item}
                  updateHandler={handleChange}
                />
              ))}
            </Grid>
          </Grid>
        )}
      </Container>
    </>
  );
}
